// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"bee43aab","455":"e7ab27fe","481":"b2cf8537","626":"0673f065","651":"87ccdd1d","833":"bf992d74","977":"730185d1"}[chunkId] + ".chunk.js";
};